// home的相关请求
import req from './index'

//登录
export const Test = (params) => {
  return req.post('/?m=bmdgl&c=hdgl&a=hdgl_edit&type=get', params)
}

//修改密码
export const SetPassword = (params) => {
  return req.post('/api/admin.php?s=Admin.Airport.AlterPass', params)
}

//通用 获取用户信息
export const GetUserInfo = (params) => {
  return req.post('api/admin.php?s=Admin.M3Drone.Dock_MyProfile', params)
}

//获取所有权限
export const getAllPermissions = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.GetUserMenu', params)
}

//获取机场电量
export const getDockElectricityApi = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.GetBatteryCapacityPercent', params)
}
